import { styled } from '@/stitches.config';

import { Box } from '@base-app';
import { ReactComponent as Check } from '@assets/icons/checkbox-empty.svg';
import { ReactComponent as CheckedCheck } from '@assets/icons/checkbox-checked.svg';
import { ReactComponent as Caution } from '@assets/icons/caution.svg';

const checkboxStyles = {
  $$checkboxDisabled: '$colors$coolGray100',
  $$checkboxHover: '$colors$coolGray300',
  variants: {
    disabled: {
      true: {
        color: '$coolGray100',
        cursor: 'not-allowed',
      },
    },
  },
  color: '',
  display: 'inline-block',
  width: '$6',
  height: '$6',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '$$checkboxHover',
  },
  top: '$2',
  left: '$2',
  position: 'relative',
};

export const CheckboxContainerStyled = styled(Box, {
  '&:hover': {
    backgroundColor: '$colors$coolGray300',
  },
  width: '$10',
  height: '$10',
  borderRadius: '$round',
  textAlign: 'initial',
});

export const CheckboxIconStyled = styled(Check, {
  ...checkboxStyles,
  color: '$darkGray200',
});

export const CheckedCheckboxIconStyled = styled(CheckedCheck, {
  ...checkboxStyles,
  color: '$darkBlue300',
});

export const InputCheckboxStyled = styled('input', {
  margin: '$0',
  height: '$5',
  width: '$5',
  display: 'none',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  pointerEvents: 'none',
  top: '$2',
  left: '$2',
  position: 'relative',
});

export const LabelStyled = styled('label', {
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
});

export const CheckboxContainerErrorStyled = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  gap: '$1',
});

export const ErrorBoxStyled = styled(Box, {
  alignItems: 'flex-start',
  display: 'flex',
  mt: '$2',
  marginLeft: '$8',
});

export const CautionIconStyled = styled(Caution, {
  color: '$error',
  display: 'inline-block',
  height: '$6',
  width: '$6',
});

export const ErrorDescriptionStyled = styled('p', {
  color: '$error',
  display: 'inline-block',
  fontSize: '$xs',
  fontWeight: '$medium',
  mt: '$0',
  mb: '$0',
});
